import React from 'react';

// nodejs library to set properties for components
import PropTypes from "prop-types";

// material-ui components
import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";


//Creamos un componente stateles, ya que no necesitamos nigun estado y son mas rapidos
function OthelloTitulo({ ...props }) {

    const {
        titulo,
        backgroundColor,
        color,
        fontSize = 18,
        borderRadius = 3,
        marginBottom = 2,
        children
    } = props;
  

        return (
            <MDBox
                sx={{
                    backgroundColor: backgroundColor != null ? backgroundColor : '#1976d2',
                    color: color != null ? color : '#ffffff',
                    borderRadius: borderRadius != null ? borderRadius : 3,
                    px: 2,
                    py: 1,
                    mb: marginBottom != null ? marginBottom : 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    minHeight: 50,
                }}
            >
                <MDTypography
                    variant="subtitle1"
                    sx={{
                        fontSize: fontSize != null ? fontSize : 18,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        color: color != null ? color : '#ffffff',
                    }}
                >
                    {titulo}
                </MDTypography>
                <MDBox>
                    {children}
                </MDBox>
            </MDBox>
        );
    };

    export default OthelloTitulo;

/*
    const {        
        titulo,  
        marginBottom,
        backgroundColor,
        borderRadius,
        color,
        fontSize
    } = props;

   
    return (
        <div style={{
            backgroundColor: backgroundColor != null ? backgroundColor : '#6C757D', height: 40, color: color != null ? color : '#ffffff', paddingLeft: 15, textAlign: 'justify',
            fontSize: fontSize != null ? fontSize : 18, borderRadius: borderRadius != null ? borderRadius : 3,
            marginBottom: marginBottom != null ? marginBottom : 15, paddingRight: 5
        }}>
            <div style={{ float: 'right' }}>{props.children}</div>
            <p style={{ paddingTop: 6, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}>{titulo}</p>
        </div>                
    );  
}

export default (OthelloTitulo);*/

OthelloTitulo.propTypes = {    
    titulo: PropTypes.string, 
    marginBottom: PropTypes.number,
    color: PropTypes.string, 
    backgroundColor: PropTypes.string, 
    borderRadius: PropTypes.number,
    fontSize: PropTypes.number
};       